import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function fetchNotifications (filialId) {
    return axios.get(`${CRM_API_URL}/notifications`, { params: { filialId } }).then(response => response.data)
}

/**
 * Прочитать уведомления FAKT Support: ids - «Прочитано» у строк, без ids - «Прочитать все».
 * Прочитанность серверная и своя у каждого сотрудника (прочие типы CRM помнят её в localStorage).
 */
function readNotifications (filialId, ids = null) {
    const body = ids ? { filialId, ids } : { filialId }

    return axios.post(`${CRM_API_URL}/notifications/read`, body).then(response => response.data)
}

export default { fetchNotifications, readNotifications }
